import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Modal from '../../components/external/Modal';
import '../../styles/external/App.css';
import { useEnvValue } from '../../config/env';

export default function SenhaNova() {
  const API_BASE_URL = useEnvValue('REACT_APP_URL_API');
  const [senha, setSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [uuid, setUuid] = useState('');
  const [tokenValido, setTokenValido] = useState('');
  const [authToken, setAuthToken] = useState('');
  const [modalData, setModalData] = useState({ show: false, title: '', message: '', redirect: false });
  const [senhaDiferente, setSenhaDiferente] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const storedUuid = localStorage.getItem('uuid');
    const storedToken = localStorage.getItem('tokenValido');
    const storedAuth = localStorage.getItem('jwt');

    if (!storedUuid || !storedToken || !storedAuth) {
      setModalData({
        show: true,
        title: 'Erro de autenticação',
        message: 'Dados de autenticação ausentes. Redirecionando...',
        redirect: true
      });
      return;
    }

    setUuid(storedUuid);
    setTokenValido(storedToken);
    setAuthToken(storedAuth);
  }, []);

  const handleCloseModal = () => {
    setModalData({ ...modalData, show: false });

    if (modalData.redirect) {
      navigate('/cadastro');
    }
  };

  const handleSenhaChange = (e) => {
    setSenha(e.target.value);
    setSenhaDiferente(e.target.value !== confirmacao && confirmacao !== '');
  };

  const handleConfirmacaoChange = (e) => {
    setConfirmacao(e.target.value);
    setSenhaDiferente(e.target.value !== senha && e.target.value !== '');
  };

  const isFormularioValido = () => {
    return senha.trim() !== '' && confirmacao.trim() !== '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isFormularioValido()) {
      setModalData({
        show: true,
        title: 'Campos obrigatórios',
        message: 'Preencha os dois campos de senha.'
      });
      return;
    }

    if (senha !== confirmacao) {
      setModalData({
        show: true,
        title: 'Senhas diferentes',
        message: 'As senhas digitadas não coincidem.'
      });
      return;
    }

    try {
      const csrfResponse = await axios.get(`${API_BASE_URL}/csrf/token`, {
        withCredentials: true
      });

      const csrfToken = csrfResponse.data?.csrfToken;

      await axios.post(
        `${API_BASE_URL}/notas/criar-senha`,
        {
          uuid: uuid,
          token: tokenValido,
          novaSenha: senha
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            'X-CSRF-Token': csrfToken
          },
          withCredentials: true
        }
      );

      setModalData({
        show: true,
        title: 'Sucesso',
        message: 'Senha definida com sucesso!',
        redirect: true
      });
    } catch (error) {
      console.error('Erro ao definir senha:', error.response?.data || error.message);
      setModalData({
        show: true,
        title: 'Erro ao salvar',
        message: 'Erro ao definir a senha. Verifique os dados e tente novamente.'
      });
    }
  };

  return (
    <div className="container">
      <Modal
        show={modalData.show}
        title={modalData.title}
        message={modalData.message}
        onClose={handleCloseModal}
      />

      <div className="left">
        <h1>Nova Senha</h1>

        <form className="form" onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Senha"
            className="input"
            value={senha}
            onChange={handleSenhaChange}
          />
          <input
            type="password"
            placeholder="Confirme a Senha"
            className="input"
            value={confirmacao}
            onChange={handleConfirmacaoChange}
          />
          {senhaDiferente && (
            <div style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>
              As senhas digitadas não coincidem.
            </div>
          )}
          <button
            type="submit"
            className="button"
            disabled={!isFormularioValido()}
            style={{
              marginTop: '15px',
              opacity: !isFormularioValido() ? 0.5 : 1,
              cursor: !isFormularioValido() ? 'not-allowed' : 'pointer'
            }}
          >
            Salvar Senha
          </button>
        </form>
      </div>
    </div>
  );
}
